import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import SiteLogo from 'components/SiteLogo';
import HeaderLocation from 'components/HeaderLocation';

const Header = ({ isTranslationReady = false }) => {
  return (
    <Box
      as="header"
      className="App-header site-header-wrapper"
      id="header-wrapper"
      position="relative"
    >
      <Flex
        className="region region-header"
        px={4}
        py={1}
        alignItems="center"
        display={{ base: 'flex', md: 'none' }}
        bg="gray.800"
        _dark={{ bg: 'tmtBlack' }}
        color="white"
        minHeight="35px"
      >
        {isTranslationReady && <HeaderLocation />}
      </Flex>
      <Flex
        id="header"
        className="site-header"
        layerStyle="lightContrastBox"
        borderBottom="1px"
        justify="space-between"
        alignItems="center"
        wrap="wrap"
      >
        <SiteLogo />
        <Flex
          className="region region-header"
          grow="1"
          textAlign="right"
          px={5}
          justifyContent="flex-end"
          alignItems="center"
          // mr="79px"
          display={{ base: 'none', md: 'flex' }}
        >
          {isTranslationReady && <HeaderLocation />}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
